var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linear/building-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "building-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66675 22H22.6667",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6768 21.9898L3.67676 22.0099L3.66675 7.06986C3.66675 6.39986 4.00676 5.77983 4.55676 5.40983L8.55676 2.73984C9.22676 2.28984 10.1067 2.28984 10.7767 2.73984L14.7767 5.40983C15.3367 5.77983 15.6667 6.39986 15.6667 7.06986L15.6768 21.9898Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.6467 22.01V18",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.6667 12C19.5667 12 18.6667 12.9 18.6667 14V16C18.6667 17.1 19.5667 18 20.6667 18C21.7667 18 22.6667 17.1 22.6667 16V14C22.6667 12.9 21.7667 12 20.6667 12Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.66675 14H15.6667",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.66675 22V18.25",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.66675 10.5C10.4952 10.5 11.1667 9.82843 11.1667 9C11.1667 8.17157 10.4952 7.5 9.66675 7.5C8.83832 7.5 8.16675 8.17157 8.16675 9C8.16675 9.82843 8.83832 10.5 9.66675 10.5Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturing);
export default __webpack_public_path__ + "static/media/Manufacturing.f171df55e76cefb752659b039c9037fd.svg";
export { ForwardRef as ReactComponent };